module.exports = __webpack_public_path__ + "img/19.671e78d3.jpg";